import styled from "styled-components/macro";
import { Button, Button as AntdButton, Input } from "antd";
import { DefaultFont } from "../../../styles/fonts";
import { ThreeDots } from "@styled-icons/bootstrap";
import { ChatItemRoot } from "../ChatsList/styles";
import { Root as InfoBoxRoot } from "../../InfoBox/InfoBox";

export const ChatsListContainer = styled.div<{ $collapsed: boolean }>`
  padding: 0 24px;
  border-right: 1px solid #dfe1eb;
  display: ${(p) => (p.$collapsed ? "none" : "flex")};
  flex-direction: column;
  width: 400px;
  @media (max-width: 820px) {
    width: 300px;
  }
`;
export const MessagesListContainer = styled.div<{ $collapsed: boolean }>`
  flex-grow: 1;
  height: 100%;
  display: ${(p) => (p.$collapsed ? "none" : "flex")};
  flex-direction: column;
`;
export const RightSidebarContainer = styled.div`
  min-width: 320px;
  max-width: 320px;
  border-left: 1px solid #dfe1eb;
  overflow-y: auto;
`;
export const ChatsListTitle = styled.div`
  font-weight: ${({ theme }) => theme.font.weightMedium};
  font-family: ${({ theme }) => theme.text.family};
  line-height: ${({ theme }) => theme.text.defaultLineHeight};
  font-size: 22px;
  color: ${({ theme }) => theme.colors.chatTextColor};
  margin-top: 34px;
  margin-bottom: 24px;
`;
export const MessagesListHeader = styled.div`
  padding: 32px 24px;
  border-bottom: 1px solid #dfe1eb;
  display: flex;
`;
export const ChatRoomStatusContainer = styled.div``;

export const SearchInput = styled(Input)`
  background: #f5f5f5;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 16px;

  &,
  &:focus {
    border: none;
    box-shadow: none;
  }

  input {
    background: #f5f5f5;
  }
`;

export const NoSelectedChat = styled.div`
  ${DefaultFont};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const PersonalInfo = styled.div`
  ${DefaultFont};
  font-size: 18px;
  color: ${(p) => p.theme.colors.chatTextColor};
  display: flex;
  padding-left: 4px;
`;

export const HeaderName = styled.div`
  font-weight: ${(p) => p.theme.font.weightMedium};
`;

export const ActivityInfo = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 10px;
  font-size: 14px;
  align-items: center;
`;
export const ActiveValue = styled.div<{ isOnline: boolean }>`
  color: #acacac;
  &:before {
    content: "●";
    margin-right: 5px;
    color: ${(p) => (p.isOnline ? "green" : "#acacac")};
  }
`;

export const OnlineIndicator = styled.div<{ isOnline: boolean }>`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: ${(p) => (p.isOnline ? "green" : "#acacac")};
`;
export const OnlineIndicatorText = styled.div`
  color: #acacac;
`;

export const HeaderLeftSide = styled.div``;

export const HeaderLeftSizePersonal = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const HeaderRightSide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const HouseButton = styled(AntdButton)`
  ${DefaultFont};
  font-size: 16px;
  color: ${(p) => p.theme.colors.chatTextColor};
  padding-left: 0;
  padding-right: 0;

  &:hover {
    color: ${(p) => p.theme.colors.bgDark} !important;
    span {
      color: ${(p) => p.theme.colors.bgDark} !important;
    }
  }
`;

export const ProfileButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  .dropdown-item {
    ${DefaultFont};
    font-size: 16px;
    color: ${(p) => p.theme.colors.chatTextColor};
  }
`;
export const DropdownIcon = styled(ThreeDots)`
  cursor: pointer;
  width: 20px;
`;

export const NoMatchYetMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;

  border: 1px solid black;
  border-radius: 8px;
  margin: 0 16px 16px 16px;
  ${DefaultFont};
  font-size: 16px;
  font-weight: ${(p) => p.theme.font.weightMedium};
  background: ${(p) => p.theme.colors.primary};
  color: white;
`;

export const ChatLayout = styled.div`
  display: flex;
  background: white;
  border-top: 2px solid #dfe1eb;
  height: calc(
    var(--app-height) - ${(props) => props.theme.sizes.headerHeight}
  );

  ${ChatRoomStatusContainer} {
    display: block;
  }

  & .sendInviteModal > section {
    max-height: calc(100vh - 10%);
  }

  @media (max-width: 1500px) {
    ${ChatsListContainer} {
      width: 300px;
      padding: 0 8px;
    }
    ${ChatItemRoot} {
      padding: 8px;
    }
  }

  @media (max-width: 1330px) {
    ${RightSidebarContainer} {
      display: none;
    }
    ${ChatRoomStatusContainer} {
      display: block;
    }
  }

  @media (max-width: 845px) {
    height: calc(
      var(--app-height) - ${(props) => props.theme.sizes.mobileHeaderHeight}
    );
  }

  @media (max-width: 768px) {
    ${ChatsListContainer} {
      width: 100vw;
    }

    ${MessagesListHeader} {
      padding: 8px 8px;
    }
  }

  @media ${(props) => props.theme.media.tablet} {
    ${RightSidebarContainer} {
      display: none;
    }
    ${ChatRoomStatusContainer} {
      display: block;
    }
  }

  @media ${(props) => props.theme.media.phone} {
    ${RightSidebarContainer} {
      display: none;
    }
    ${ChatRoomStatusContainer} {
      display: block;
    }
    ${PersonalInfo} {
      display: none;
    }
    ${HeaderName} {
      max-width: 100px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    ${HouseButton} {
      span {
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 0.875rem;
      }
    }
    ${InfoBoxRoot} {
      display: none;
    }
    ${ActivityInfo} {
      font-size: 12px;
      margin-top: 0;
    }
    ${HeaderRightSide} {
      justify-content: start;
    }

    ${ProfileButtonContainer} {
      font-size: 0.875rem !important;
    }
  }
`;

export const BackButton = styled(Button)`
  height: 100%;
  margin-right: 20px;
  padding-left: 0;
  padding-right: 0;
  border: none;

  svg {
    height: 30px;
  }
`;

export const HostVerificationContainer = styled.div`
  padding-left: 8px;

  div {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  label {
    align-self: flex-start;
    justify-content: flex-start;
    text-align: left;
  }

  @media (max-width: 520px) {
    .status-title {
      display: none;
    }
  }
`;
